module.exports = __webpack_public_path__ + "static/media/sb_tip2.f6c4b783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/sb_tip2.jpg
// module id = 543
// module chunks = 0